import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import logo from "../logo.svg";

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState(null);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const solutions = [
    { name: "Funding", path: "/solutions/funding" },
    { name: "Execution", path: "/solutions/execution" },
    { name: "Planning", path: "/solutions/planning" },
    { name: "Invoice Handling", path: "/solutions/invoice-handling" },
  ];

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? "bg-white/95 backdrop-blur-xl shadow-lg border-b border-gray-100/50"
          : "bg-white/80 backdrop-blur-xl border-b border-transparent"
      }`}
    >
      <nav className="container-custom py-4">
        <div className="flex items-center justify-between">
          <Link to="/" className="flex items-center">
            <img src={logo} alt="Estabild" className="h-8 w-auto" />
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center space-x-8">
            <div className="relative group">
              <button
                className="text-gray-700 hover:text-primary-500 font-body font-medium transition-colors"
                onMouseEnter={() => setActiveDropdown("solutions")}
              >
                Solutions
              </button>
              {activeDropdown === "solutions" && (
                <div
                  className="absolute top-full left-0 mt-2 w-56 bg-white/95 backdrop-blur-xl shadow-xl rounded-2xl py-2 border border-gray-100/50 animate-fade-in"
                  onMouseLeave={() => setActiveDropdown(null)}
                >
                  {solutions.map((solution) => (
                    <Link
                      key={solution.path}
                      to={solution.path}
                      className="block px-4 py-2 text-gray-700 hover:bg-primary-50 hover:text-primary-600 transition-all duration-200 font-body rounded-lg mx-2"
                    >
                      {solution.name}
                    </Link>
                  ))}
                </div>
              )}
            </div>
            <Link
              to="/pricing"
              className="text-gray-700 hover:text-primary-500 font-body font-medium transition-colors"
            >
              Pricing
            </Link>
            <Link
              to="/about"
              className="text-gray-700 hover:text-primary-500 font-body font-medium transition-colors"
            >
              About
            </Link>
          </div>

          <div className="hidden lg:flex items-center space-x-6">
            <a
              href="https://app.estabild.com"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-700 hover:text-primary-500 font-body font-medium transition-colors"
            >
              Log in
            </a>
            <Link to="/contact">
              <button className="btn-primary">Book demo</button>
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="lg:hidden text-gray-700 hover:text-primary-600 transition-colors p-2 rounded-lg hover:bg-gray-100"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            <svg
              className="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              {isMobileMenuOpen ? (
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              ) : (
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M4 6h16M4 12h16M4 18h16"
                />
              )}
            </svg>
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="lg:hidden mt-4 pb-4 border-t border-gray-200/50 pt-4 animate-slide-up">
            <div className="flex flex-col space-y-4">
              <div>
                <p className="font-semibold text-gray-900 mb-2">Solutions</p>
                <div className="pl-4 space-y-2">
                  {solutions.map((solution) => (
                    <Link
                      key={solution.path}
                      to={solution.path}
                      className="block text-gray-700 hover:text-primary-600"
                      onClick={() => setIsMobileMenuOpen(false)}
                    >
                      {solution.name}
                    </Link>
                  ))}
                </div>
              </div>
              <Link
                to="/pricing"
                className="text-gray-700 hover:text-primary-600 font-medium"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                Pricing
              </Link>
              <Link
                to="/about"
                className="text-gray-700 hover:text-primary-600 font-medium"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                About
              </Link>
              <a
                href="https://app.estabild.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-700 hover:text-primary-600 font-medium"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                Log in
              </a>
              <Link to="/contact" onClick={() => setIsMobileMenuOpen(false)}>
                <button className="btn-primary w-full">Contact us</button>
              </Link>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
};

export default Header;
